export default __webpack_public_path__ + "static/media/Fclc_Logo_Sub.cdc3ae2b.png";